import React from 'react';
import classNames from 'classnames';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { Button, CloseButton } from 'modules/ui';
import styles from './ConfirmationDialog.module.scss';

export default function ConfirmationDialog({
  onAction,
  onCancel,
  message = '',
  actionBtnLabel = 'Discard',
  cancelBtnLabel = 'Keep editing',
  title,
  withOverlay,
  inProgress,
  subtitleText,
  titleStyle,
  subtitleClassName,
}) {
  const buttonClasses = classNames(styles.button);
  const textClasses = classNames('body16', styles.text);
  const subtitleClasses = classNames(styles.subtitle, subtitleClassName);
  const titleId = 'confirmation-dialog-title';
  const messageId = 'confirmation-dialog-message';

  return (
    <Dialog
      open
      onClose={onCancel}
      hideBackdrop={!withOverlay}
      aria-labelledby={titleId}
      aria-describedby={messageId}
      slotProps={{
        paper: {
          className: styles.container,
        },
      }}
    >
      <DialogTitle className={styles.title}>
        <h2 id={titleId} style={titleStyle}>
          {title}
        </h2>
        <div className={styles.closeButtonContainer}>
          <CloseButton onClick={onCancel} />
        </div>
      </DialogTitle>
      <DialogContent className={styles.content}>
        {subtitleText && <div className={subtitleClasses}>{subtitleText}</div>}
        <DialogContentText id={messageId} className={textClasses}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={styles.footer}>
        <Button
          secondary
          autoFocus
          className={buttonClasses}
          onClick={onCancel}
        >
          {cancelBtnLabel}
        </Button>
        <Button
          primary
          className={buttonClasses}
          onClick={onAction}
          loading={inProgress}
        >
          {actionBtnLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
